import React, { Component } from 'react';
import './styles/style.scss';
import { PrimaryButton as pb, SecondaryButton as sb, TertiaryButton as tb, GhostButton as gb, GhostSecondaryButton as gs, GhostTertiaryButton as gt, FilledButton as fb, NeutralButton as nb, DangerButton as db, WhatsappButton as wab, FacebookButton as fbb, TwitterButton as trb, MessengerButton as mgb, GoogleButton as glb, SmallPrimaryButton as spb, SmallSecondaryButton as ssb, SmallTertiaryButton as stb, SmallNeutralButton as snb, SmallGhostButton as sgb, SmallGhostSecondaryButton as sgsb, SmallGhostTertiaryButton as sgtb, SmallFilledButton as sfb, SmallDangerButton as sdb, LargePrimaryButton as lpb, LargeSecondaryButton as lsb, LargeTertiaryButton as ltb, LargeGhostButton as lgb, LargeNeutralButton as lnb } from './components/StyledComponents/Button';
import { getThemeConfig as getTheme } from './components/Theme';
import CustomF, { DefaultFooter as DefaultF } from './components/StyledComponents/Footer';
import CustomH, { DefaultHeader as DefaultH } from './components/StyledComponents/Header';
import { Row as Frow, Col as Fcol } from 'react-flexa';
import { FieldContainer as FieldF, FormFieldButtons as FormFButtons } from './components/StyledComponents/Form';
import Rdio, { Radios as Rdios } from './components/StyledComponents/Radio';
import Cbox, { Checkboxes as Cboxes } from './components/StyledComponents/Checkbox';
import MobileButtonList from './components/StyledComponents/MobileButtonList'; // Our Atoms

import _CenteredLogo from './components/StyledComponents/CenteredLogo';
export { _CenteredLogo as CenteredLogo };
import _Avatar from './components/StyledComponents/Avatar';
export { _Avatar as Avatar };
import _Button from './components/StyledComponents/Button';
export { _Button as Button };
export var PrimaryButton = pb;
export var SecondaryButton = sb;
export var TertiaryButton = tb;
export var GhostButton = gb;
export var GhostSecondaryButton = gs;
export var GhostTertiaryButton = gt;
export var NeutralButton = nb;
export var FilledButton = fb;
export var DangerButton = db;
export var WhatsappButton = wab;
export var FacebookButton = fbb;
export var TwitterButton = trb;
export var MessengerButton = mgb;
export var GoogleButton = glb;
export var SmallPrimaryButton = spb;
export var SmallSecondaryButton = ssb;
export var SmallTertiaryButton = stb;
export var SmallNeutralButton = snb;
export var SmallGhostButton = sgb;
export var SmallGhostSecondaryButton = sgsb;
export var SmallGhostTertiaryButton = sgtb;
export var SmallFilledButton = sfb;
export var SmallDangerButton = sdb;
export var LargePrimaryButton = lpb;
export var LargeSecondaryButton = lsb;
export var LargeTertiaryButton = ltb;
export var LargeGhostButton = lgb;
export var LargeNeutralButton = lnb;
import _Buttons from './components/StyledComponents/Buttons';
export { _Buttons as Buttons };
import _MobileButtonList from './components/StyledComponents/MobileButtonList';
export { _MobileButtonList as MobileButtonList };
import _Banner from './components/StyledComponents/Banner';
export { _Banner as Banner };
export var Checkbox = Cbox;
export var Checkboxes = Cboxes;
import _InputFile from './components/StyledComponents/InputFile';
export { _InputFile as InputFile };
import _InputButton from './components/StyledComponents/InputButton';
export { _InputButton as InputButton };
import _InputText from './components/StyledComponents/InputText';
export { _InputText as InputText };
import _InputSelect from './components/StyledComponents/InputSelect';
export { _InputSelect as InputSelect };
import _PageButtons from './components/StyledComponents/PageButtons';
export { _PageButtons as PageButtons };
import _ButtonGroup from './components/StyledComponents/ButtonGroup';
export { _ButtonGroup as ButtonGroup };
import _AutoCompleteAddress from './components/StyledComponents/AutoCompleteAddress';
export { _AutoCompleteAddress as AutoCompleteAddress };
export var Radio = Rdio;
export var Radios = Rdios;
import _Switch from './components/StyledComponents/Switch';
export { _Switch as Switch };
import _TextArea from './components/StyledComponents/TextArea';
export { _TextArea as TextArea };
import _Select from './components/StyledComponents/Select';
export { _Select as Select };
import _SiteProgress from './components/StyledComponents/SiteProgress';
export { _SiteProgress as SiteProgress };
import _Slider from './components/StyledComponents/Slider';
export { _Slider as Slider };
import _ProductSlider from './components/StyledComponents/Slider/ProductSlider';
export { _ProductSlider as ProductSlider };
import _Eyebrow from './components/StyledComponents/Eyebrow';
export { _Eyebrow as Eyebrow };
import _Header from './components/StyledComponents/Header2';
export { _Header as Header2 };
import _Header_OM from './components/Partners/OM/Header';
export { _Header_OM as Header_OM };
import _Footer_OM from './components/Partners/OM/Footer';
export { _Footer_OM as Footer_OM };
import _Burger_OM from './components/Partners/OM/Burger';
export { _Burger_OM as Burger_OM };
import _Buttom_OM from './components/Partners/OM/Button';
export { _Buttom_OM as Buttom_OM };
import _QuickQuoteGroup from './components/StyledComponents/Quickquote/group';
export { _QuickQuoteGroup as QuickQuoteGroup };
import _QuickQuoteDomestic from './components/StyledComponents/Quickquote/domestic';
export { _QuickQuoteDomestic as QuickQuoteDomestic };
import _QuickQuoteFamily from './components/StyledComponents/Quickquote/family';
export { _QuickQuoteFamily as QuickQuoteFamily };
import _LeadformGroup from './components/StyledComponents/Leadform/group';
export { _LeadformGroup as LeadformGroup };
import _Leadform from './components/StyledComponents/Leadform';
export { _Leadform as Leadform };
import _Heading from './components/StyledComponents/Heading';
export { _Heading as Heading };
import _Spinner from './components/StyledComponents/Spinner';
export { _Spinner as Spinner };
import _LoadingRow from './components/StyledComponents/LoadingRow';
export { _LoadingRow as LoadingRow };
import _SegmentedButton from './components/StyledComponents/SegmentedButton';
export { _SegmentedButton as SegmentedButton };
import _Form from './components/StyledComponents/Form';
export { _Form as Form };
import _Field from './components/StyledComponents/Form/Field';
export { _Field as Field };
export var FieldContainer = FieldF;
export var FormFieldButtons = FormFButtons;
import _Modal from './components/StyledComponents/Modal';
export { _Modal as Modal };
import _PricingPopup from './components/StyledComponents/PricingPopup';
export { _PricingPopup as PricingPopup };
import _Testimonial from './components/StyledComponents/Testimonial';
export { _Testimonial as Testimonial };
import _Table from './components/StyledComponents/Table';
export { _Table as Table };
import _Hint from './components/StyledComponents/Hint';
export { _Hint as Hint }; // Theme

import _Theme from './components/Theme/';
export { _Theme as Theme };
export var getThemeConfig = getTheme;
import _constants from './constants';
export { _constants as constants }; // Grid

import _Grid from './components/StyledComponents/Grid';
export { _Grid as Grid };
export var Row = Frow;
export var Col = Fcol; // Our Organisms

export var Footer = CustomF;
export var DefaultFooter = DefaultF;
export var Header = CustomH;
export var DefaultHeader = DefaultH;
import _Wrapper from './components/StyledComponents/Wrapper';
export { _Wrapper as Wrapper };
import _Section from './components/StyledComponents/Section';
export { _Section as Section };
import _AppContainer from './components/StyledComponents/AppContainer';
export { _AppContainer as AppContainer };
import _Desktop from './components/StyledComponents/Desktop';
export { _Desktop as Desktop };
import _Mobile from './components/StyledComponents/Mobile';
export { _Mobile as Mobile }; // Landing Page

import _Features from './components/LandingPages/Features1';
export { _Features as Features1 };
import _Features2 from './components/LandingPages/Features2';
export { _Features2 as Features2 };
import _Features3 from './components/LandingPages/Features9';
export { _Features3 as Features9 };
import _Features4 from './components/LandingPages/Features14';
export { _Features4 as Features14 };
import _Features5 from './components/LandingPages/Features23';
export { _Features5 as Features23 };
import _Features6 from './components/LandingPages/Features24';
export { _Features6 as Features24 };
import _Gallery from './components/LandingPages/Gallery5';
export { _Gallery as Gallery5 };
import _Gallery2 from './components/LandingPages/Gallery8';
export { _Gallery2 as Gallery8 };
import _Text from './components/LandingPages/Text2';
export { _Text as Text2 };
import _Text2 from './components/LandingPages/Text6';
export { _Text2 as Text6 };
import _Text3 from './components/LandingPages/Text7';
export { _Text3 as Text7 };
import _Text4 from './components/LandingPages/Text16';
export { _Text4 as Text16 };
import _Text5 from './components/LandingPages/Text17';
export { _Text5 as Text17 };
import _Cta from './components/LandingPages/Cta1';
export { _Cta as Cta1 };
import _Cta2 from './components/LandingPages/Cta2';
export { _Cta2 as Cta2 };
import _Cta3 from './components/LandingPages/Cta4';
export { _Cta3 as Cta4 };
import _Cta4 from './components/LandingPages/Cta11';
export { _Cta4 as Cta11 };
import _Cta5 from './components/LandingPages/Cta14';
export { _Cta5 as Cta14 };
import _LandingPage from './components/LandingPages';
export { _LandingPage as LandingPage };
import _SimplyLogo from './components/StyledComponents/Logo';
export { _SimplyLogo as SimplyLogo }; //Minheight

import * as mh from './components/StyledComponents/Minheight';
export var Minheight = mh.default; //Containers

import { TwoPane } from './components/StyledComponents/Containers';
import { Shadowed } from './components/StyledComponents/Containers';
import { Gradient } from './components/StyledComponents/Containers';
import { GradientPane } from './components/StyledComponents/Containers';
import { GradientPrimary } from './components/StyledComponents/Containers';
import { GradientSecondary } from './components/StyledComponents/Containers';
import { GradientTertiary } from './components/StyledComponents/Containers';
import { Centered } from './components/StyledComponents/Containers';
import { Overlay } from './components/StyledComponents/Containers';
export var GradientContainer = Gradient;
export var GradientPaneContainer = GradientPane;
export var GradientPrimaryContainer = GradientPrimary;
export var GradientSecondaryContainer = GradientSecondary;
export var GradientTertiaryContainer = GradientTertiary;
export var CenteredContainer = Centered;
export var ShadowedContainer = Shadowed;
export var OverlayConatiner = Overlay;
export var TwoPaneContainer = TwoPane; //EXPORT BLOCK

import _Block from './components/StyledComponents/Block';
export { _Block as Block }; //PARTNER CONSTANTS

import _RML from './themes/rml';
export { _RML as RML };